import React from "react";

const GovernmentSupportTab = () => {
  return <> Government Support </>;
};

export default GovernmentSupportTab;